import PopupRecoveryPassword from './PopupRecoveryPassword';

export default PopupRecoveryPassword;
